const SCROLL_DIRECTION = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
};

export default SCROLL_DIRECTION;
